import { api } from "./api";

const websiteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Contacts endpoints
    getWebsiteContacts: builder.query({
      query: () => "/all_web_contact",
      providesTags: ["websiteContacts"],
    }),
    updateWebsiteContact: builder.mutation({
      query: ({ id, data }) => ({
        url: `/update_web_contact/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["websiteContacts"],
    }),
    deleteWebsiteContact: builder.mutation({
      query: (id) => ({
        url: `/delete_web_contact/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["websiteContacts"],
    }),
    createWebsiteContact: builder.mutation({
      query: (data) => ({
        url: `/create_web_contact`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["websiteContacts"],
    }),

    // Products endpoints
    getWebsiteProducts: builder.query({
      query: () => "/all_web_product",
      providesTags: ["websiteProducts"],
    }),
    getWebsiteProductById: builder.query({
      query: (id) => `/web_product/${id}`,
      providesTags: ["websiteProducts"],
    }),
    createWebsiteProduct: builder.mutation({
      query: (data) => ({
        url: `/create_web_product`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["websiteProducts"],
    }),
    updateWebsiteProduct: builder.mutation({
      query: ({ id, data }) => ({
        url: `/update_web_product/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["websiteProducts"],
    }),
    deleteWebsiteProduct: builder.mutation({
      query: (id) => ({
        url: `/delete_web_product/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["websiteProducts"],
    }),
  }),
});

export const {
  useGetWebsiteContactsQuery,
  useCreateWebsiteContactMutation,
  useUpdateWebsiteContactMutation,
  useDeleteWebsiteContactMutation,

  useGetWebsiteProductsQuery,
  useGetWebsiteProductByIdQuery,
  useCreateWebsiteProductMutation,
  useUpdateWebsiteProductMutation,
  useDeleteWebsiteProductMutation,
} = websiteApi;
